module.exports = __webpack_public_path__ + "img/WohinGehts.596db747.svg";